"use client";
import { Button } from "@/components/ui/button";
import { useWinnersCtx } from "@/contexts/winners";
import {
  DropDownIcon,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslation } from "@/i18n/client";
import { useLocaleCtx } from "@/contexts/locale";
import GradientBorder from "@/components/common/gradient-border";

export default function TopBar() {
  const { category, setCategory, categories } = useWinnersCtx();

  return (
    <>
      <div className="relative mx-auto hidden sm:block">
        <div className="flex w-screen overflow-hidden overflow-x-auto bg-foreground px-6 py-2 backdrop-blur-md sm:w-fit sm:justify-center sm:gap-4 sm:rounded-full sm:px-10 sm:py-2 lg:py-4">
          <GradientBorder className="z-10" />
          {categories?.map((cat) => {
            const isActive = cat.title === category.title;

            return (
              <div key={cat.title} className="relative">
                {isActive && (
                  <div className="absolute inset-x-0 -bottom-2 z-40 h-[1px] bg-white sm:-bottom-2 lg:-bottom-4" />
                )}
                <Button
                  variant="ghost"
                  onClick={() =>
                    setCategory({
                      title: cat.title,
                      value: cat.value,
                    })
                  }
                  className={`relative z-20 rounded-none text-xs font-normal text-[#FFCC68] 2xl:text-base ltr:font-opensans ${isActive ? "" : "opacity-40"}`}
                >
                  {cat.title}
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export function MobileItems() {
  const { category, setCategory, categories } = useWinnersCtx();
  const { lang } = useLocaleCtx();
  const { t } = useTranslation(lang, "common");

  return (
    <div className="flex items-center gap-2 sm:hidden">
      <div className="flex-shrink-0 text-sm text-secondary/40 ltr:font-opensans">
        {t("filterBy")}:
      </div>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger className="h-12 w-full rounded-full bg-foreground px-4 text-sm text-secondary backdrop-blur-md sm:py-3">
          <div className="flex items-center justify-between gap-2 text-xs sm:text-sm ltr:font-opensans">
            {category.title}
            <DropDownIcon />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="bg-foreground text-secondary backdrop-blur-md">
          {categories?.map((cat) => (
            <DropdownMenuItem
              key={cat.title}
              className="cursor-pointer ltr:font-opensans"
              onClick={() =>
                setCategory({
                  title: cat.title,
                  value: cat.value,
                })
              }
            >
              {cat.title}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
